exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input_width_5a57371{width:400px!important}.selectW_1bac6a8{display:inline-block!important;margin-right:10px;width:125px!important}.textarea_b59fa86{width:400px!important;height:200px}.textarea_b59fa86 .k-textarea{height:200px!important;resize:none}.tip_765eab4{width:400px;margin-top:10px;color:#f40d0d}.anchor_box_70c1dec{width:140px!important}", ""]);

// exports
exports.locals = {
	"input_width": "input_width_5a57371",
	"selectW": "selectW_1bac6a8",
	"textarea": "textarea_b59fa86",
	"tip": "tip_765eab4",
	"anchor_box": "anchor_box_70c1dec"
};